export const GET_CONSENTS_REQUEST = 'app/WithConsent/GET_CONSENTS_REQUEST';
export const GET_CONSENTS_SUCCESS = 'app/WithConsent/GET_CONSENTS_SUCCESS';
export const GET_CONSENTS_FAILURE = 'app/WithConsent/GET_CONSENTS_FAILURE';

export const WITH_CONSENT = 'WithConsent';
